//  ----------      START   IMPORT  BLOCK       ----------
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
//  Widgets
import { Card, Spinner, Alert, Button } from 'react-bootstrap';
//  Services
import VerifyService from '../../API/Services/VerifyService';
//  Context
import { useLanguage } from '../../API/Context/LanguageContext';
//  Config
import VocabVerificationScreen from '../../ConfigFiles/multilingual/VocabVerificationScreen';
//  ----------      START   IMPORT  BLOCK       ----------

const VerificationScreen = ({  }) => {
  //  Consume context
  const { lan } = useLanguage()

  const [verified, setVerified] = useState(null); // null = pending, true = success, false = error
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const verifyService = new VerifyService();


  useEffect(() => {
    const token = searchParams.get('token');
    console.log('token:', token)
    if (!token) {
      setError('Invalid verification link.');
      setVerified(false);
      return;
    }

    const verifyUser = async () => {
      try {
        await verifyService.verify(token).then(response => {
            console.log("Verified successfully:", response);
          })
          .catch(error => {
            console.error("Failed to verify:", error);
          });
        setVerified(true);
      } catch (err) {
        console.error('Verification failed:', err);
        setError(VocabVerificationScreen.failure_message[lan]);
        setVerified(false);
      }
    };

    verifyUser();
  }, [searchParams]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Card className="shadow" style={{ width: '30rem' }}>
        <Card.Header className="text-center fs-4">
          {VocabVerificationScreen.verifying[lan]}
        </Card.Header>
        <Card.Body className="text-center">
          {verified === null && (
            <>
              <Spinner animation="border" role="status" />
              <p className="mt-3">{VocabVerificationScreen.if_success[lan]}</p>
            </>
          )}

          {verified === true && (
            <Alert variant="success">
              {VocabVerificationScreen.success_message[lan]}
              <div className="mt-3">
                <Button onClick={() => navigate('/login')}>
                  {VocabVerificationScreen.login_button[lan] || 'Go to Login'}
                </Button>
              </div>
            </Alert>
          )}

          {verified === false && (
            <Alert variant="danger">
              {error}
              <div className="mt-3">
                <Button onClick={() => navigate('/register')}>
                  {VocabVerificationScreen.retry_button[lan] || 'Try Again'}
                </Button>
              </div>
            </Alert>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default VerificationScreen;
